import { throttle } from 'throttle-debounce';

document.addEventListener("DOMContentLoaded", function () {
    /**
     * 著作権表記：©記号の後ろに2017-{今年の西暦4桁}を追加
     */
    const footerElement = document.querySelector("#wrapper-footer .site-info");
    if (footerElement) {
        const currentYear = new Date().getFullYear();
        footerElement.innerHTML = footerElement.innerHTML.replace("©", `© 2017-${currentYear}`);
    }

    /**
     * フレキシブルテーブル独自のCSSを削除
     */
    const styleElement = document.getElementById('flexible-table-block-inline-css');
    if (styleElement) {
        styleElement.remove();
        console.log('Style element with ID flexible-table-block-inline-css has been removed.');
    }

    /**
     * ナビゲーションのハイライト自動化処理
     */
    const currentUrl = (location.origin + location.pathname).split('?')[0].split('#')[0];
    const navLinks = document.querySelectorAll('.entry-content .nav .nav-link');
    navLinks.forEach(function (link) {
        if (link.href === currentUrl && !link.classList.contains('active')) {
            link.classList.add('active');
        }
    });


    /**
     * 上部ナビゲーションバーのスクロール時表示処理
     */

    const { body } = document;
    const className = 'scroll-down';
    console.log(throttle);
    let previousScrollY = 0;
    const removeBodyClass = () => body.classList.remove(className);
    const toggleBodyClass = () => {
        const currentScrollY = window.scrollY;
        const navbar = document.querySelector('.navbar');
        const navbarHeight = navbar.clientHeight;
        if (currentScrollY > navbarHeight) {
            if (currentScrollY > previousScrollY + 80) {
                body.classList.add(className);
            } else if (currentScrollY < previousScrollY - 20) {
                removeBodyClass();
            }
        } else {
            removeBodyClass();
        }
        previousScrollY = currentScrollY;
    };
    window.addEventListener('scroll', throttle(300, toggleBodyClass), false);

    /**
     * サイドバー（オフキャンバス）の開閉処理
     */
    const toggleButton = document.querySelector('.btn-toggle-offcanvas');
    const storageKey = 'offcanvasState';
    // ボタンがクリックされた時の動作
    toggleButton.addEventListener('click', () => {
        body.classList.toggle('closed-offcanvas');
        // 状態をローカルストレージに保存
        if (body.classList.contains('closed-offcanvas')) {
            localStorage.setItem(storageKey, 'closed');
        } else {
            localStorage.setItem(storageKey, 'open');
        }
    });
    // ページロード時にローカルストレージから状態を取得
    const savedState = localStorage.getItem(storageKey);
    if (savedState === 'closed') {
        window.setTimeout(function () { toggleButton.click(); }, 1000);
    }

    /**
     * 所属ステータス管理
     */
    // レクチャ
    const navLectureMain = document.querySelector("#nav-lecture-main");
    const navLectureTokyo = document.querySelector("#nav-lecture-tokyo");

    // ローカルに 所属ステータス を保存
    const currentURL = window.location.href;
    if (currentURL.includes("lecture/main")) {
        localStorage.setItem("membership", "main");
    } else if (currentURL.includes("lecture/tokyo")) {
        localStorage.setItem("membership", "tokyo");
    } else if (navLectureMain && navLectureTokyo) {
        // lecture/main も lecture/tokyo もURLに含まれない場合
        const storedLecture = localStorage.getItem("membership");
        if (storedLecture === "tokyo") {
            navLectureMain.remove();  // tokyo が保存されている場合、本部ナビゲーション を消す
        } else {
            navLectureTokyo.remove();  // main が保存かそれ以外の場合、東京支部ナビゲーション を消す
            localStorage.setItem("membership", "main");
        }
    }

    // トップページ
    const tabPanelTabs = document.querySelector("#front__tabpanel__tabs");
    if (tabPanelTabs) {
        const mainTabLink = tabPanelTabs.querySelector('a[href="#tab_front_main"]');
        const tokyoTabLink = tabPanelTabs.querySelector('a[href="#tab_front_tokyo"]');

        if (mainTabLink) {
            // 本部タブをクリックした時に "main" を保存
            mainTabLink.addEventListener('click', () => {
                localStorage.setItem("membership", "main");  // mainタブをクリックした時に "main" を保存
            });
        }
        if (tokyoTabLink) {
            // 東京支部タブをクリックした時に "tokyo" を保存
            tokyoTabLink.addEventListener('click', () => {
                localStorage.setItem("membership", "tokyo");  // tokyoタブをクリックした時に "tokyo" を保存
            });
        }

        const storedMembership = localStorage.getItem("membership");
        // 所属ステータス応じて切替
        if (storedMembership === "main") {
            if (mainTabLink) {
                // 本部をローカル保存し、本部タブをクリック
                window.setTimeout(function () { mainTabLink.click(); }, 1000);
            }
        } else if (storedMembership === "tokyo") {
            if (tokyoTabLink) {
                // 東京支部をローカル保存し、東京支部タブをクリック
                window.setTimeout(function () { tokyoTabLink.click(); }, 1000);
            }
        }

    }

    /**
     * 各リンクの拡張子が.pdfの場合は 新規ウィンドウで開く
     */
    document.querySelectorAll('a').forEach(link => {
        // URLからパラメータやアンカー部分を除去
        const url = link.href.split('#')[0].split('?')[0];
        // 拡張子が .pdf かどうかをチェック
        if (url.endsWith('.pdf')) {
            link.setAttribute('target', '_blank');
        }
    });

    /**
     * 各リンクのURLが外部ドメインの場合は、新規ウィンドウで開く
     */
    const links = document.querySelectorAll('a:not([target])');
    if (links.length === 0) {
        console.warn("リンクが見つかりませんでした。");
        return;
    }
    const currentDomain = window.location.hostname;
    links.forEach(link => {
        try {
            const url = new URL(link.href);
            const isExternal = url.hostname !== currentDomain;
            const isValidLink = (url.protocol === 'http:' || url.protocol === 'https:');
            if (isExternal && isValidLink) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            }
        } catch (error) {
            console.error(`リンクの処理中にエラーが発生しました: ${link.href}`, error);
        }
    });

    /**
     * フォーム入力処理
     */

    // フォームの取得
    const targetForm = document.querySelector(".wpcf7-form");

    if (targetForm) {

        /* 学籍番号桁数処理
         * ----------------------------------------------- */
        const inputField = targetForm.querySelector("input[name=your-code]");
        if (inputField) {
            inputField.addEventListener("blur", function () {
                if (this.value !== "") {
                    this.value = this.value.substring(0, 5).padStart(5, '0');
                }
            });
        }

        /* 学科選択時の学年コントロール
         * ----------------------------------------------- */
        const setDeptYearLimit = (deptSelector) => {
            const myTarget = document.querySelector("input#depts");
            if (myTarget) {
                const myDate = new Date();
                const myDept = JSON.parse(myTarget.value.replace(/'/g, "\""));
                const classSelector = deptSelector.closest("fieldset").querySelector("select[name$='-class']");
                let adjustYear = myDate.getFullYear() - parseInt(myTarget.dataset.baseY);

                // 学科が選択されていない場合の表示メッセージ
                const defaultOption = document.createElement("option");
                defaultOption.value = "";
                if (!deptSelector.value) {
                    defaultOption.textContent = "—先に学科を選択してください—";
                } else {
                    defaultOption.textContent = "—以下から選択してください—";
                }
                classSelector.innerHTML = "";
                classSelector.appendChild(defaultOption);

                // 学科が選択されている場合の処理
                if (deptSelector.value) {
                    const deptSelectorSelected = deptSelector.value;
                    // 学科から該当項目を探す
                    for (const dept of myDept) {
                        // 後方一致していれば
                        if (deptSelectorSelected.endsWith(dept.id)) {
                            // 学科が存在する場合、学年の基準年との差分を追加
                            if (dept.count !== "TRUE") {
                                adjustYear = 0;
                            }
                            // 学年の追加調整
                            for (let j = 0; j < (parseInt(dept.max) + adjustYear); j++) {
                                const option = document.createElement("option");
                                option.value = j + 1;
                                option.textContent = j + 1;
                                classSelector.appendChild(option);
                            }
                            break;
                        }
                    }
                }
            }
        };

        // ページ読み込み時に処理を実行
        window.addEventListener("load", () => {
            document.querySelectorAll("select[name='dept'], select[name$='-dept']").forEach(select => {
                setDeptYearLimit(select);
            });
        });

        // 学科選択時に学年を変更するイベントリスナーを追加
        document.addEventListener("change", (event) => {
            if (event.target.matches("select[name='dept'], select[name$='-dept']")) {
                setDeptYearLimit(event.target);
            }
        });



        /* 帰天年月日の初期値制御
         * ----------------------------------------------- */
        const myDate = new Date();
        const currentYear = myDate.getFullYear();

        document.querySelectorAll("select[name='returnee-k-year']").forEach(select => {
            // 現在の年で始まる選択肢要素を探す
            const matchingOption = Array.from(select.options).find(option =>
                option.value.startsWith(currentYear.toString())
            );
            // 見つかれば、その値を学年選択肢の値に設定
            if (matchingOption) {
                select.value = matchingOption.value;
            }
        });

    }

    /**
     * フォーム文字変換処理
     */
    // 全角英数字を半角英数字に変換する関数
    const toHalfWidth = (str) => {
        return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) =>
            String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
        );
    };
    // 半角カタカナを全角カタカナに変換する関数
    const toFullWidthKatakana = (str) => {
        const kanaMap = {
            'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
            'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
            'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
            'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
            'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
            'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
            'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
            'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
            'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
            'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
            'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
            'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
            'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
            'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
            'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
            'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
            'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
            'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
            '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
        };

        const reg = new RegExp(`(${Object.keys(kanaMap).join('|')})`, 'g');
        return str.replace(reg, match => kanaMap[match]).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
    };
    // 全角カタカナを全角ひらがなに変換する関数
    const katakanaToHiragana = (str) => {
        return str.replace(/[\u30A1-\u30F6]/g, (s) =>
            String.fromCharCode(s.charCodeAt(0) - 0x60)
        );
    };
    // 全角ひらがなを全角カタカナに変換する関数
    const hiraganaToKatakana = (str) => {
        return str.replace(/[\u3041-\u3096]/g, (s) =>
            String.fromCharCode(s.charCodeAt(0) + 0x60)
        );
    };
    // フォームのテキスト入力に対する処理
    document.querySelectorAll('input[type="text"], textarea').forEach((element) => {
        element.addEventListener('blur', (event) => {
            let value = event.target.value;
            // 全角英数字を半角英数字に変換
            value = toHalfWidth(value);
            // 半角カタカナを全角カタカナに変換
            value = toFullWidthKatakana(value);
            // name属性に`kana`を含む場合
            if (event.target.name.includes('kana')) {
                // カタカナをひらがなに変換
                value = katakanaToHiragana(value);
            }
            // フィールドの値を更新
            event.target.value = value;
        });
    });



});